import { useQuery } from '@apollo/client';

import INTEGRITY_SETTINGS_QUERY from 'bundles/academic-integrity/components/viva-exam/api/GradingIntegritySettingsQuery.graphql';

import type {
  QueryGradingIntegritySettingsQuery,
  QueryGradingIntegritySettingsQueryVariables,
} from './__generated__/GradingIntegritySettingsQuery';

type UseIntegritySettingsProps = {
  courseId: string;
  assessmentId: string | undefined;
  sessionId: string | undefined;
};

export const useIntegritySettings = (props: UseIntegritySettingsProps) => {
  const {
    // We're relying on `skip` below if any of these are non-truthy
    courseId = '',
    assessmentId = '',
    sessionId = '',
  } = props;
  const [assessmentIdNoVersion, assessmentVersion] = assessmentId.split('@');
  const { data, loading, error } = useQuery<
    QueryGradingIntegritySettingsQuery,
    QueryGradingIntegritySettingsQueryVariables
  >(INTEGRITY_SETTINGS_QUERY, {
    variables: {
      settingsIds: [
        {
          assessmentId: assessmentIdNoVersion,
          assessmentType: 'ASSIGNMENT',
          assessmentVersion: Number(assessmentVersion),
          courseId,
          sessionId,
        },
      ],
    },
    context: { clientName: 'gatewayGql' },
    skip: !courseId || !assessmentId || !sessionId,
  });

  const [integritySettings] = data?.IntegritySettingsV2?.queryIntegritySettings ?? [];

  return {
    integritySettings,
    loading,
    error,
  };
};

export default useIntegritySettings;
